/*
NOTE
This section was previously known as wgyc

But this section is now known as 'Services'

It is mapped to Services navitem in Navbar and it's id is 'services'
*/

import './WGYC.css'
import React, { useState, useEffect, useRef } from 'react'
import { useInView } from 'framer-motion'
import SectionIds from '../../Helper/SectionId'
import wgycData from '../../Data/WGYC'
import { FeatureCard } from '../../Components/Card/FeatureCard';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics'


export default function WGYC() {
    const [activeCard, setActiveCard] = useState(0);
    const [pauseTimer, setPauseTimer] = useState(false);

    const sectionRef = useRef(null);
    const inView = useInView(sectionRef);
    
    const startTimer = () => {
        setPauseTimer(false);
    };

    const stopTimer = () => {
        setPauseTimer(true);
    };

    useEffect(() => {
        if (inView) {
            setActiveCard(0);
            startTimer();
        } else {
            stopTimer();
        }
    }, [inView]);



    useEffect(() => {

        const timer = setInterval(() => {
            if (!pauseTimer) {
                setActiveCard(prevActiveCard => {
                    if (prevActiveCard === wgycData.length - 1) {
                        return 0;
                    } else {
                        return prevActiveCard + 1;
                    }
                });
            }
        }, 2000);

        return () => clearInterval(timer);
    }, [pauseTimer]);

    return (
        <SectionWithAnalytics className='section container-vertical res-gap-32' id={SectionIds.sectionWGYC}>
            <div className='container-vertical res-gap-24'>
                <h3 className='text-align-center'>
                    We've got you <mark>Covered</mark>
                </h3>
                <div className='text-align-center fs-medium clr-grey-600 fw-regular'>
                    Get advice according to your tier. Contact us now!
                </div>
            </div>
            <ul className='content-grid res-gap-16'>

                {
                    wgycData.map((element, index) => (
                        <FeatureCard
                            key={index}
                            icon={element.icon()}
                            title={element.title}
                            className={index === activeCard ? 'active' : ''}
                            content={element.content}
                            onMouseOver={() => {
                                setPauseTimer(true);
                                setActiveCard(index);
                            }}
                            onMouseLeave={() => {
                                setPauseTimer(false);
                            }}
                        />
                    ))
                }
            </ul>


        </SectionWithAnalytics>
    )
}
